(function (angular) {
    'use strict';

    angular.module('integration')
        /**
         * simple filter that just groups revoked tokens together at the end
         */
        .filter("accessTokenFilter", [function () {

            return function (accessTokens) {

                accessTokens.sort(function (a, b) {
                    return new Date(b._createdOn) - new Date(a._createdOn);
                });

                var _accessTokens = [];
                var _revokedAccessTokens = [];

                angular.forEach(accessTokens, function (token) {
                    if (token.revokedOn) {
                        _revokedAccessTokens.push(token);
                    } else {
                        _accessTokens.push(token);
                    }
                });

                return _accessTokens.concat(_revokedAccessTokens);
            }
        }]);

})(window.angular);
